function initializeProductCardInventory() {
  // Use event delegation on the document body. This is more efficient and
  // works for products loaded dynamically (e.g., via "Load More" buttons).
  document.body.addEventListener('click', function(event) {
    // The clickable element for your variants is a <label>.
    const picker = event.target.closest('.m-product-option--node__label');

    // Check if the clicked element is a variant picker and is inside a variant picker container
    if (!picker || !picker.closest('[data-pcard-variant-picker]')) {
      return; // Exit if it's not a variant picker click
    }

    const card = picker.closest('.m-product-card');
    if (!card) {
      return; // Exit if we can't find the parent product card
    }

    // A short delay is necessary to wait for your theme's main script
    // to finish updating the product state and the hidden input field.
    setTimeout(() => {
      const selectedVariantIdInput = card.querySelector('input[name="id"]');
      if (!selectedVariantIdInput) return;

      const selectedVariantId = selectedVariantIdInput.value;
      const inventoryStatuses = card.querySelectorAll('.m-product-card__inventory');

      inventoryStatuses.forEach(statusEl => {
        if (statusEl.dataset.variantId === selectedVariantId) {
          statusEl.style.display = 'block'; // Show the correct status
        } else {
          statusEl.style.display = 'none'; // Hide all others
        }
      });
    }, 100); // 100ms is a safer delay than 50ms
  });
}

// Run the initialization function once the document is ready.
// This handles the initial page load.
document.addEventListener('DOMContentLoaded', initializeProductCardInventory);

// This handles re-running the logic when sections are reloaded in the Shopify Theme Editor.
document.addEventListener('shopify:section:load', initializeProductCardInventory);